<p-dialog 
    [(visible)]="visible" 
    [modal]="true" 
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    [style]="{ width: '500px' }"
    header="Select Signing Flow">
    
    <div class="signing-flow-content">
        <p class="mb-4 text-center">Select who should sign the envelope:</p>
        
        <div class="signing-options">
            <div 
                class="signing-option" 
                [class.selected]="isSelected('Vendor')"
                (click)="selectFlow('Vendor')">
                <i class="pi pi-user icon"></i>
                <div class="option-label">Vendor Only</div>
            </div>

            <div 
                class="signing-option" 
                [class.selected]="isSelected('Reviewer')"
                (click)="selectFlow('Reviewer')">
                <i class="pi pi-eye icon"></i>
                <div class="option-label">Reviewer Only</div>
            </div>

            <div 
                class="signing-option" 
                [class.selected]="isSelected('Both')"
                (click)="selectFlow('Both')">
                <i class="pi pi-users icon"></i>
                <div class="option-label">Both</div>
            </div>
        </div>

        @if (!selectedFlow) {
            <p class="text-danger text-center mt-3 mb-0">
                <small><i class="pi pi-exclamation-triangle"></i> Please select at least one option</small>
            </p>
        }
    </div>

    <ng-template pTemplate="footer">
        <div class="d-flex gap-2 justify-content-end">
            <p-button 
                label="Cancel" 
                severity="secondary" 
                [outlined]="true"
                (onClick)="onCancel()">
            </p-button>
            <p-button 
                label="Confirm" 
                severity="primary"
                [disabled]="!selectedFlow"
                (onClick)="onConfirm()">
            </p-button>
        </div>
    </ng-template>
</p-dialog>
